import { doc, setDoc } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';
import { describeMutation } from '@siteless/resource';
import { OneUserFavoritesResource } from './One';

export let setUserFavoritesMutation = describeMutation(
  'setUserFavoritesMutation',
  async ({
    userId,
    favorites,
  }: {
    userId: string;
    favorites: {
      type: 'film' | 'person';
      key: string;
    }[];
  }) => {
    await OneUserFavoritesResource.yield(userId, favorites);

    try {
      await setDoc(
        doc(database, 'users', userId),
        {
          favorites: {
            [thisOscarsYear]: favorites,
          },
        },
        { merge: true },
      );
    } catch (error) {
      console.error(error);
      await OneUserFavoritesResource.refresh(userId);
    }
  },
);

export let toggleUserFavoriteMutation = describeMutation(
  'toggleUserFavoriteMutation',
  async ({
    userId,
    favorites,
    favorite,
  }: {
    userId: string;
    favorites: {
      type: 'film' | 'person';
      key: string;
    }[];
    favorite: {
      type: 'film' | 'person';
      key: string;
    };
  }) => {
    let updatedFavorites = favorites;

    if (favorites.find(({ key }) => key === favorite.key)) {
      updatedFavorites = favorites.filter(({ key }) => key !== favorite.key);
    } else {
      updatedFavorites = [favorite, ...favorites];
    }

    await OneUserFavoritesResource.yield(userId, updatedFavorites);

    try {
      await setDoc(
        doc(database, 'users', userId),
        {
          favorites: {
            [thisOscarsYear]: updatedFavorites,
          },
        },
        { merge: true },
      );
    } catch (error) {
      console.error(error);
      await OneUserFavoritesResource.refresh(userId);
    }
  },
);
